import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import AppointmentForm from "@/components/AppointmentForm";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import { usePageMeta } from "@/seo";

export default function LandingPage() {
  usePageMeta("/");
  return (
    <main className="min-h-screen bg-[#F7F5F0]" data-testid="landing-page">
      <Header />
      <Hero />
      <About />
      <Services />
      <AppointmentForm />
      <Testimonials />
      <Footer />
    </main>
  );
}
